module.exports = __webpack_public_path__ + "img/zy-bottom_bg.39876943.png";